import type { Action, Mutation } from 'vuex'
import type {
  DestinationDetailList,
  RecipientOption,
  RecipientDetailsModel,
} from '@/api/send_cart/model/sendCartModel'

import actionTypes from './actionTypes'
import { getDetail, getDetailAll } from '@/api/recipient_master/recipientMaster'
export interface Search {
  sort_column: string
  sort: string
  page_size: number
  page_number: number
  corporate_name: string
  client_name: string
  recipient_user_name: string
}
export interface State {
  recipientDetailListDisplay: DestinationDetailList
  recipientDetailListOriginal: DestinationDetailList
  detail: RecipientDetailsModel
  search: Search
  detailAll: Array<RecipientMasterDetailAllType>
  detailStatus: number
}

export interface RecipientMasterDetailAllType {
  client_code: string
  client_name: string
  corporate_name: string
  corporate_name_sort: string
  corporate_number: number
  recipient_department_name: string
  recipient_detail_id: number
  recipient_id: number
  recipient_mail: string
  recipient_user_id: number
  recipient_user_name: string
  corporate_number_string?: string
}

const state = (): State => ({
  recipientDetailListDisplay: [],
  recipientDetailListOriginal: [],
  detail: {
    current_page: 0,
    total_count: 0,
    detail: [],
  } as RecipientDetailsModel,
  search: {
    sort_column: 'initial',
    sort: 'ASC',
    page_size: 20,
    page_number: 1,
    corporate_name: '',
    client_name: '',
    recipient_user_name: '',
  },
  detailStatus: 0,
  detailAll: [],
})

const actions: { [actionType: string]: Action<State, any> } = {
  async [actionTypes.SET_RECIPIENT_DETAIL_LIST]({ commit }, item: RecipientOption) {
    commit(actionTypes.SET_RECIPIENT_DETAIL_LIST, [])
  },

  [actionTypes.SET_RECIPIENT_DETAIL]: async (
    { commit, state },
    status: number
  ): Promise<void> => {
    // リストを取得
    const result = await getDetail(status, state.search)
    commit(actionTypes.SET_RECIPIENT_DETAIL, result.data)
    commit(actionTypes.SET_RECIPIENT_DETAIL_STATUS, result.status)
  },

  [actionTypes.SET_RECIPIENT_DETAIL_ALL]: async (
    { commit },
    status: number
  ): Promise<void> => {
    // リストを取得
    const result = await getDetailAll(status)
    commit(actionTypes.SET_RECIPIENT_DETAIL_ALL, result)
  },

  [actionTypes.SET_SEARCH]: async ({ commit }, data: Search): Promise<void> => {
    commit(actionTypes.SET_SEARCH, data)
  },
}

const mutations: { [actionType: string]: Mutation<State> } = {
  [actionTypes.SET_RECIPIENT_DETAIL_LIST](state) {
    state.recipientDetailListDisplay = []
    state.recipientDetailListOriginal = []
  },

  [actionTypes.SET_RECIPIENT_DETAIL](state: State, data: any) {
    state.detail = data
  },

  [actionTypes.SET_RECIPIENT_DETAIL_STATUS](state: State, data: number) {
    state.detailStatus = data
  },

  [actionTypes.SET_SEARCH](state: State, data: Search) {
    state.search = data
  },

  [actionTypes.SET_RECIPIENT_DETAIL_ALL](state: State, data: any) {
    state.detailAll = []
    if (data.detail.length > 0) {
      state.detailAll = data.detail.map((item: RecipientMasterDetailAllType) => ({
        ...item,
        corporate_number_string: item.corporate_number.toString() ?? '',
      }))
    }
  },
}

export { actionTypes }

export default {
  namespace: true,
  state,
  actions,
  mutations,
}
